export default "__VITE_ASSET__Dd_kxbsx__"